import './TestimonyForm.scss';
import { useState, useRef } from "react";
import StarRating from "../stars/StarRating";
import axios from "../../api/axios";

export default function TestimonyForm() {

    const [formData, setFormData] = useState({
        customerName: "",
        rating: 0.1,
        comments: "",
        testimonySource: "Shisha",
        verified: "Not Verified",
        readOn: "https://oldkent-shisha.co.uk/testimonyp"
    });

    const fileInputRef = useRef(null);
    const [successMsg, setSuccessMsg] = useState("");
    const [avatar, setAvatar] = useState(null);
    const [avatarPreview, setAvatarPreview] = useState(null);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleAvatarChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setAvatar(file);
        setAvatarPreview(URL.createObjectURL(file));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();

        Object.entries(formData).forEach(([key, value]) =>
            data.append(key, value)
        );

        if (avatar) data.append("avatar", avatar);

        try {
            await axios.post("/v/testimonials", data);

            setSuccessMsg("Your testimony has been submitted successfully!");

            setTimeout(() => setSuccessMsg(""), 4000);

            setFormData({
                customerName: "",
                rating: 0.5,
                comments: "",
                testimonySource: "Shisha",
                verified: "Not Verified",
                readOn: "https://oldkent-shisha.co.uk/testimonyp"
            });

            setAvatar(null);
            setAvatarPreview(null);
            if (fileInputRef.current) fileInputRef.current.value = "";

        } catch (err) {
            setSuccessMsg("Failed to submit testimony.");
            setTimeout(() => setSuccessMsg(""), 4000);
        }
    };

    return (
        <div className="testimony-form"> {/* Replaced .form-box */}
            <h2>Leave Your Testimony</h2>

            {successMsg && (
                <div className="success-message">{successMsg}</div>
            )}

            <form onSubmit={handleSubmit}>

                {/* Avatar Upload */}
                <div
                    className="avatar-preview"
                    onClick={() => fileInputRef.current.click()}
                >
                    {avatarPreview ? (
                        <img src={avatarPreview} alt="Avatar" />
                    ) : (
                        <div className="placeholder">
                            Click to Upload
                        </div>
                    )}
                </div>

                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleAvatarChange}
                    accept="image/*"
                    style={{ display: "none" }}
                />

                {/* Text inputs */}
                <input
                    type="text"
                    name="customerName"
                    placeholder="Your Name"
                    value={formData.customerName}
                    onChange={handleChange}
                    required
                />

                {/* Star Rating */}
                <StarRating
                    value={formData.rating}
                    onChange={(rating) =>
                        setFormData({ ...formData, rating })
                    }
                />

                <textarea
                    name="comments"
                    placeholder="Write your testimony..."
                    value={formData.comments}
                    onChange={handleChange}
                    required
                />

                <button type="submit">Submit</button>
            </form>
        </div>
    );
}
